import { useEffect, useRef } from "react";

import { useDispatch, useSelector } from "@/redux/hooks";
import { getLocationState } from "@/redux/selectors/location";
import { disableLocationChangeReload } from "@/redux/slices/header";

const useCustomLocationPickerUpdateBehavior = (
  onLocationChange: () => void,
) => {
  const dispatch = useDispatch();
  const { coordinates } = useSelector(getLocationState);
  const { lat, lon } = coordinates;

  const prevCoordsRef = useRef<{ lat: number; lon: number } | null>(null);

  useEffect(() => {
    dispatch(disableLocationChangeReload());
  }, [dispatch]);

  useEffect(() => {
    if (!prevCoordsRef.current) {
      prevCoordsRef.current = { lat, lon };
      return;
    }

    const hasCoordsChanged =
      prevCoordsRef.current.lat !== lat || prevCoordsRef.current.lon !== lon;

    if (hasCoordsChanged) {
      onLocationChange();

      prevCoordsRef.current = { lat, lon };
    }
  }, [lat, lon, onLocationChange]);
};
export default useCustomLocationPickerUpdateBehavior;
